export default __webpack_public_path__ + "df28bacdedd83439ceed84d6c5b10458.png";